import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from "react";
import tw from "tailwind-styled-components";
import { SButton, SIcon, SIconType } from "../components";
import Icon from "../icons";
const Container = tw.div`
  relative
  text-md
`;
const FakeButton = tw.button`
  inline-flex
  justify-center
  items-center
  gap-1
  transition-all
  rounded-md
  text-accent-light

  hover:bg-opacity-7

  ${({ $isButtonStyle })=>$isButtonStyle ? `
    p-[10px]
    bg-brand-primary
    bg-opacity-10
  ` : ""}
`;
const SizeStyles = {
    sm: "text-[11px]",
    md: "text-sm",
    lg: "text-base",
    xl: "text-lg"
};
export const FileUploader = ({ ariaLabel = "upload", handleFile, hasError = false, handleRetry, accept = "image/*", hideText = false, hideIcon = false, isButtonStyle = false, size = "md", buttonSize = "md", customSize = "", isSuiButton = false, suiButtonProps = {}, buttonChildren, disabled = false, isLoading = false, progress })=>{
    const hiddenFileInput = useRef(null);
    const sizeStyles = SizeStyles[size];
    const handleClick = (e)=>{
        e.preventDefault();
        if (hiddenFileInput && hiddenFileInput.current) {
            hiddenFileInput.current.click();
        }
    };
    const handleChange = async (e)=>{
        e.preventDefault();
        const target = e?.target;
        if (target?.files && target?.files[0]) {
            await handleFile(target.files[0]);
            if (hiddenFileInput && hiddenFileInput?.current) {
                hiddenFileInput.current.value = "";
            }
        }
    };
    const onClickButton = async (e)=>{
        e.preventDefault();
        if (isLoading) return;
        if (hasError) {
            handleRetry(e);
        } else {
            handleClick(e);
        }
    };
    const _text = hideText ? "" : hasError ? "Retry" : "Upload";
    const text = buttonChildren && !hasError ? buttonChildren : _text;
    const widthAndHeight = customSize ? {
        width: customSize,
        height: customSize
    } : {};
    return /*#__PURE__*/ _jsxs(Container, {
        children: [
            isSuiButton ? /*#__PURE__*/ _jsxs(SButton, {
                disabled: disabled || isLoading,
                onClick: onClickButton,
                size: buttonSize,
                ...suiButtonProps,
                children: [
                    text,
                    !hideIcon && /*#__PURE__*/ _jsx(_Fragment, {
                        children: hasError ? /*#__PURE__*/ _jsx(Icon, {
                            name: "MdRefresh",
                            size: "lg"
                        }) : isLoading ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                progress && /*#__PURE__*/ _jsxs("span", {
                                    className: "text-xs",
                                    children: [
                                        progress,
                                        "%"
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(SIcon, {
                                    type: "spinner",
                                    className: "animate-spin",
                                    size: 16
                                })
                            ]
                        }) : // <Icon name="MdOutlineFileUpload" size="lg" />
                        /*#__PURE__*/ _jsx(SIcon, {
                            size: 16,
                            type: SIconType.Upload
                        })
                    })
                ]
            }) : /*#__PURE__*/ _jsxs(FakeButton, {
                disabled: disabled || isLoading,
                onClick: onClickButton,
                $isButtonStyle: isButtonStyle,
                className: `${sizeStyles}`,
                style: widthAndHeight,
                children: [
                    text,
                    !hideIcon && /*#__PURE__*/ _jsx(_Fragment, {
                        children: hasError ? /*#__PURE__*/ _jsx(Icon, {
                            name: "MdRefresh",
                            size: "lg"
                        }) : isLoading ? /*#__PURE__*/ _jsx(SIcon, {
                            type: "spinner",
                            className: "animate-spin",
                            size: 16
                        }) : /*#__PURE__*/ _jsx(Icon, {
                            name: "MdOutlineFileUpload",
                            size: "lg"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("input", {
                type: "file",
                ref: hiddenFileInput,
                onChange: handleChange,
                style: {
                    display: "none"
                },
                accept: accept,
                "aria-label": ariaLabel
            })
        ]
    });
};
